import { SenderId } from "tng-address-collection-shared/types/apiTypes.ts";

export const initialSenderId = (
  projectDefaultSenderId: SenderId | undefined,
  userUidNumber: number | undefined,
): SenderId | undefined =>
  projectDefaultSenderId ??
  (userUidNumber ? { type: "employee", uidNumber: userUidNumber } : undefined);
